<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Multifunkčn&eacute; tlačiarne XC9225, XC9235, XC9245, XC9255, XC9265">
     Multifunkčn&eacute; tlačiarne XC9225, XC9235, XC9245, XC9255, XC9265
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety-information-chapter.html#safety-information-chapter_sk" title="Inform&aacute;cie o&nbsp;bezpečnosti">
     Inform&aacute;cie o&nbsp;bezpečnosti
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Zauž&iacute;van&eacute; označenie">
      Zauž&iacute;van&eacute; označenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="product-statements-group.html#d0e42" title="Vyhl&aacute;senia o&nbsp;produkte">
      Vyhl&aacute;senia o&nbsp;produkte
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sk" title="Obozn&aacute;menie sa s&nbsp;tlačiarňou">
     Obozn&aacute;menie sa s&nbsp;tlačiarňou
    </a>
   </p>
   <div id="divd0e191">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sk" title="Vyhľad&aacute;vanie inform&aacute;ci&iacute; o&nbsp;tlačiarni">
      Vyhľad&aacute;vanie inform&aacute;ci&iacute; o&nbsp;tlačiarni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_sk" title="V&yacute;ber miesta pre tlačiareň">
      V&yacute;ber miesta pre tlačiareň
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sk" title="Konfigur&aacute;cie tlačiarne">
      Konfigur&aacute;cie tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sk" title="Prip&aacute;janie k&aacute;blov">
      Prip&aacute;janie k&aacute;blov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sk" title="Použ&iacute;vanie ovl&aacute;dacieho panela">
      Použ&iacute;vanie ovl&aacute;dacieho panela
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_sk" title="Pochopenie v&yacute;znamu stavu tlačidla nap&aacute;jania a&nbsp;svetla indik&aacute;tora">
      Pochopenie v&yacute;znamu stavu tlačidla nap&aacute;jania a&nbsp;svetla indik&aacute;tora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_sk" title="Použ&iacute;vanie domovskej obrazovky">
      Použ&iacute;vanie domovskej obrazovky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sk" title="Tlač strany nastaven&iacute; pon&uacute;k">
      Tlač strany nastaven&iacute; pon&uacute;k
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sk" title="Nastavenie a&nbsp;použ&iacute;vanie aplik&aacute;ci&iacute; na domovskej obrazovke">
     Nastavenie a&nbsp;použ&iacute;vanie aplik&aacute;ci&iacute; na domovskej obrazovke
    </a>
   </p>
   <div id="divd0e1016">
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sk" title="Prisp&ocirc;sobenie domovskej obrazovky">
      Prisp&ocirc;sobenie domovskej obrazovky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-card-copy-topic.html#setting-up-card-copy_sk" title="Nastavenie kop&iacute;rovania preukazov">
      Nastavenie kop&iacute;rovania preukazov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-shortcut-center-topic.html#using-shortcut-center_sk" title="Použ&iacute;vanie Centra skratiek">
      Použ&iacute;vanie Centra skratiek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#setting-up-scan-center_sk" title="Nastavenie Scan Centra">
      Nastavenie Scan Centra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_sk" title="Použ&iacute;vanie aplik&aacute;cie Podpora pre z&aacute;kazn&iacute;kov">
      Použ&iacute;vanie aplik&aacute;cie Podpora pre z&aacute;kazn&iacute;kov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_sk" title="Nastavenie kv&oacute;t zariadenia">
      Nastavenie kv&oacute;t zariadenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_sk" title="Použ&iacute;vanie funkcie Prisp&ocirc;sobenie displeja">
      Použ&iacute;vanie funkcie Prisp&ocirc;sobenie displeja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1227" title="Spr&aacute;va z&aacute;ložiek">
      Spr&aacute;va z&aacute;ložiek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1304" title="Spr&aacute;va kontaktov">
      Spr&aacute;va kontaktov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_sk" title="Nastavenie a&nbsp;použ&iacute;vanie funkci&iacute; zjednodu&scaron;enia ovl&aacute;dania">
     Nastavenie a&nbsp;použ&iacute;vanie funkci&iacute; zjednodu&scaron;enia ovl&aacute;dania
    </a>
   </p>
   <div id="divd0e1423">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_sk" title="Zapnutie režimu zv&auml;č&scaron;enia">
      Zapnutie režimu zv&auml;č&scaron;enia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_sk" title="Aktiv&aacute;cia hlasov&yacute;ch pokynov">
      Aktiv&aacute;cia hlasov&yacute;ch pokynov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_sk" title="&Uacute;prava r&yacute;chlosti reči hlasov&yacute;ch pokynov">
      &Uacute;prava r&yacute;chlosti reči hlasov&yacute;ch pokynov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#adjusting-default-internal-speaker-volume_sk" title="Nastavenie predvolenej hlasitosti vn&uacute;torn&eacute;ho reproduktora">
      Nastavenie predvolenej hlasitosti vn&uacute;torn&eacute;ho reproduktora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_sk" title="&Uacute;prava predvolenej hlasitosti sl&uacute;chadiel">
      &Uacute;prava predvolenej hlasitosti sl&uacute;chadiel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_sk" title="Zapnutie č&iacute;tania hesiel alebo osobn&yacute;ch identifikačn&yacute;ch č&iacute;sel">
      Zapnutie č&iacute;tania hesiel alebo osobn&yacute;ch identifikačn&yacute;ch č&iacute;sel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_sk" title="Navig&aacute;cia na obrazovke pomocou gest">
      Navig&aacute;cia na obrazovke pomocou gest
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_sk" title="Použ&iacute;vanie kl&aacute;vesnice na displeji">
      Použ&iacute;vanie kl&aacute;vesnice na displeji
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_sk" title="Vkladanie papiera a&nbsp;&scaron;peci&aacute;lnych m&eacute;di&iacute;">
     Vkladanie papiera a&nbsp;&scaron;peci&aacute;lnych m&eacute;di&iacute;
    </a>
   </p>
   <div id="divd0e1678">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type_sk" title="Nastavenie veľkosti a typu &scaron;peci&aacute;lnych m&eacute;di&iacute;">
      Nastavenie veľkosti a typu &scaron;peci&aacute;lnych m&eacute;di&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_sk" title="Konfigur&aacute;cia univerz&aacute;lnych nastaven&iacute; papiera">
      Konfigur&aacute;cia univerz&aacute;lnych nastaven&iacute; papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_sk" title="Vkladanie do z&aacute;sobn&iacute;kov">
      Vkladanie do z&aacute;sobn&iacute;kov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-2500-sheet-tray-topic.html#loading-2500-sheet-tray_sk" title="Vkladanie do 2&nbsp;500-h&aacute;rkov&eacute;ho z&aacute;sobn&iacute;ka">
      Vkladanie do 2&nbsp;500-h&aacute;rkov&eacute;ho z&aacute;sobn&iacute;ka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-3000-sheet-tray-topic.html#loading-3000-sheet-tray_sk" title="Vkladanie do 3&nbsp;000-h&aacute;rkov&eacute;ho z&aacute;sobn&iacute;ka">
      Vkladanie do 3&nbsp;000-h&aacute;rkov&eacute;ho z&aacute;sobn&iacute;ka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_sk" title="Vkladanie do viac&uacute;čelov&eacute;ho pod&aacute;vača">
      Vkladanie do viac&uacute;čelov&eacute;ho pod&aacute;vača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_sk" title="Prepojenie z&aacute;sobn&iacute;kov">
      Prepojenie z&aacute;sobn&iacute;kov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-mahi-topic.html#d0e2040" title="Podpera papiera">
      Podpera papiera
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sk" title="Tlač">
     Tlač
    </a>
   </p>
   <div id="divd0e4529">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_sk" title="Tlač z poč&iacute;tača">
      Tlač z poč&iacute;tača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4555" title="Tlač z&nbsp;mobiln&eacute;ho zariadenia">
      Tlač z&nbsp;mobiln&eacute;ho zariadenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_sk" title="Tlač z&nbsp;pam&auml;ťovej jednotky flash">
      Tlač z&nbsp;pam&auml;ťovej jednotky flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_sk" title="Podporovan&eacute; jednotky flash a&nbsp;typy s&uacute;borov">
      Podporovan&eacute; jednotky flash a&nbsp;typy s&uacute;borov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sk" title="Konfigur&aacute;cia d&ocirc;vern&yacute;ch &uacute;loh">
      Konfigur&aacute;cia d&ocirc;vern&yacute;ch &uacute;loh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sk" title="Tlač d&ocirc;vern&yacute;ch a&nbsp;in&yacute;ch zadržan&yacute;ch &uacute;loh">
      Tlač d&ocirc;vern&yacute;ch a&nbsp;in&yacute;ch zadržan&yacute;ch &uacute;loh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_sk" title="Tlač zoznamu uk&aacute;žok p&iacute;siem">
      Tlač zoznamu uk&aacute;žok p&iacute;siem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_sk" title="Tlač zoznamu adres&aacute;ra">
      Tlač zoznamu adres&aacute;ra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sk" title="Zru&scaron;enie tlačovej &uacute;lohy">
      Zru&scaron;enie tlačovej &uacute;lohy
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying-chapter.html#copying-chapter_sk" title="Kop&iacute;rovanie">
     Kop&iacute;rovanie
    </a>
   </p>
   <div id="divd0e5123">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_sk" title="Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla">
      Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_sk" title="Vytv&aacute;ranie k&oacute;pi&iacute;">
      Vytv&aacute;ranie k&oacute;pi&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_sk" title="Kop&iacute;rovanie fotografi&iacute;">
      Kop&iacute;rovanie fotografi&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_sk" title="Kop&iacute;rovanie na hlavičkov&yacute; papier">
      Kop&iacute;rovanie na hlavičkov&yacute; papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_sk" title="Kop&iacute;rovanie na obe strany papiera">
      Kop&iacute;rovanie na obe strany papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_sk" title="Zmen&scaron;enie alebo zv&auml;č&scaron;enie k&oacute;pi&iacute;">
      Zmen&scaron;enie alebo zv&auml;č&scaron;enie k&oacute;pi&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_sk" title="Zoradenie k&oacute;pi&iacute;">
      Zoradenie k&oacute;pi&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_sk" title="Umiestnenie oddeľovac&iacute;ch h&aacute;rkov medzi k&oacute;pie">
      Umiestnenie oddeľovac&iacute;ch h&aacute;rkov medzi k&oacute;pie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_sk" title="Kop&iacute;rovanie viacer&yacute;ch str&aacute;nok na jeden h&aacute;rok">
      Kop&iacute;rovanie viacer&yacute;ch str&aacute;nok na jeden h&aacute;rok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_sk" title="Vytvorenie skratky na kop&iacute;rovanie">
      Vytvorenie skratky na kop&iacute;rovanie
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_sk" title="Odosielanie e-mailov">
     Odosielanie e-mailov
    </a>
   </p>
   <div id="divd0e5409">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email_sk" title="Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla">
      Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-e-mail-topic.html#configuring-smtp-server-e-mail_sk" title="Konfigur&aacute;cia servera SMTP pre e-mail">
      Konfigur&aacute;cia servera SMTP pre e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_sk" title="Odoslanie e-mailovej spr&aacute;vy">
      Odoslanie e-mailovej spr&aacute;vy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_sk" title="Vytvorenie skratky pre e-mail">
      Vytvorenie skratky pre e-mail
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faxing-chapter.html#faxing-chapter_sk" title="Faxovanie">
     Faxovanie
    </a>
   </p>
   <div id="divd0e5564">
    <p class="toc-2-style">
     <a href="configuring-smtp-server-fax-topic.html#d0e5567" title="Nastavenie tlačiarne na faxovanie">
      Nastavenie tlačiarne na faxovanie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_sk" title="Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla">
      Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_sk" title="Odoslanie faxu">
      Odoslanie faxu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_sk" title="Napl&aacute;novanie odoslania faxu">
      Napl&aacute;novanie odoslania faxu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_sk" title="Vytvorenie skratky pre cieľov&eacute; umiestnenie pre fax">
      Vytvorenie skratky pre cieľov&eacute; umiestnenie pre fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_sk" title="Zmena rozl&iacute;&scaron;enia faxu">
      Zmena rozl&iacute;&scaron;enia faxu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_sk" title="Nastavenie tmavosti faxu">
      Nastavenie tmavosti faxu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_sk" title="Tlač denn&iacute;ka faxov">
      Tlač denn&iacute;ka faxov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_sk" title="Blokovanie nevyžiadan&yacute;ch faxov">
      Blokovanie nevyžiadan&yacute;ch faxov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_sk" title="Zadržiavanie faxov">
      Zadržiavanie faxov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_sk" title="Posielanie faxov ďalej">
      Posielanie faxov ďalej
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="ftp-chapter.html#ftp-chapter_sk" title="Skenovanie">
     Skenovanie
    </a>
   </p>
   <div id="divd0e6289">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_sk" title="Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla">
      Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_sk" title="Skenovanie na server FTP">
      Skenovanie na server FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_sk" title="Vytvorenie skratky pre FTP">
      Vytvorenie skratky pre FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_sk" title="Vytvorenie skratky pre sieťov&yacute; priečinok">
      Vytvorenie skratky pre sieťov&yacute; priečinok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_sk" title="Skenovanie na pam&auml;ťov&uacute; jednotku flash">
      Skenovanie na pam&auml;ťov&uacute; jednotku flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-scanned-documents-to-computer-topic.html#sending-scanned-documents-to-computer_sk" title="Odosielanie naskenovan&yacute;ch dokumentov do poč&iacute;tača">
      Odosielanie naskenovan&yacute;ch dokumentov do poč&iacute;tača
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sk" title="Vysvetlenie pon&uacute;k tlačiarne">
     Vysvetlenie pon&uacute;k tlačiarne
    </a>
   </p>
   <div id="divd0e6469">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_sk" title="Mapa pon&uacute;k">
      Mapa pon&uacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6882" title="Zariadenie">
      Zariadenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8992" title="Tlačiť">
      Tlačiť
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e10555" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e10970" title="Kop&iacute;rovanie">
      Kop&iacute;rovanie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e11634" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e13601" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e14589" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e15258" title="Jednotka USB">
      Jednotka USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e16112" title="Sieť/porty">
      Sieť/porty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e17957" title="Zabezpečenie">
      Zabezpečenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e19055" title="Spr&aacute;vy">
      Spr&aacute;vy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_sk" title="Pomocn&iacute;k">
      Pomocn&iacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-group.html#d0e19417" title="Rie&scaron;enie probl&eacute;mov">
      Rie&scaron;enie probl&eacute;mov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-printer-chapter.html#securing-printer-chapter_sk" title="Zabezpečenie tlačiarne">
     Zabezpečenie tlačiarne
    </a>
   </p>
   <div id="divd0e19461">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sk" title="Umiestnenie bezpečnostnej z&aacute;suvky">
      Umiestnenie bezpečnostnej z&aacute;suvky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sk" title="Vymazanie pam&auml;te tlačiarne">
      Vymazanie pam&auml;te tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_sk" title="Vymazanie pam&auml;te pevn&eacute;ho disku tlačiarne">
      Vymazanie pam&auml;te pevn&eacute;ho disku tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_sk" title="&Scaron;ifrovanie pevn&eacute;ho disku tlačiarne">
      &Scaron;ifrovanie pevn&eacute;ho disku tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sk" title="Obnovenie predvolen&yacute;ch v&yacute;robn&yacute;ch nastaven&iacute;">
      Obnovenie predvolen&yacute;ch v&yacute;robn&yacute;ch nastaven&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_sk" title="Vyhl&aacute;senie o nest&aacute;losti">
      Vyhl&aacute;senie o nest&aacute;losti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sk" title="&Uacute;držba tlačiarne">
     &Uacute;držba tlačiarne
    </a>
   </p>
   <div id="divd0e19675">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e19680" title="Pripojenie k sieti">
      Pripojenie k sieti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_sk" title="Nastavenie tlače cez s&eacute;riov&yacute; port (iba syst&eacute;m Windows)">
      Nastavenie tlače cez s&eacute;riov&yacute; port (iba syst&eacute;m Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e20026" title="Čistenie s&uacute;čast&iacute; tlačiarne">
      Čistenie s&uacute;čast&iacute; tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_sk" title="Objedn&aacute;vanie s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu">
      Objedn&aacute;vanie s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e20536" title="V&yacute;mena s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu">
      V&yacute;mena s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer_sk" title="Premiestnenie tlačiarne">
      Premiestnenie tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e21024" title="&Uacute;spora energie a&nbsp;papiera">
      &Uacute;spora energie a&nbsp;papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#d0e21128" title="Recykl&aacute;cia">
      Recykl&aacute;cia
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_sk" title="Odstraňovanie zaseknut&eacute;ho papiera">
     Odstraňovanie zaseknut&eacute;ho papiera
    </a>
   </p>
   <div id="divd0e21161">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_sk" title="Predch&aacute;dzanie zaseknutiu papiera">
      Predch&aacute;dzanie zaseknutiu papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_sk" title="Identifik&aacute;cia miest zaseknutia">
      Identifik&aacute;cia miest zaseknutia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-adf-topic.html#jam-in-adf_sk" title="Zaseknut&yacute; papier v&nbsp;automatickom pod&aacute;vači dokumentov">
      Zaseknut&yacute; papier v&nbsp;automatickom pod&aacute;vači dokumentov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jams-in-mpf-topic.html#jams-in-mpf_sk" title="Zaseknutie papiera vo viac&uacute;čelovom pod&aacute;vači">
      Zaseknutie papiera vo viac&uacute;čelovom pod&aacute;vači
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-c-topic.html#jam-in-door-c_sk" title="Zaseknut&yacute; papier v dvierkach&nbsp;C">
      Zaseknut&yacute; papier v dvierkach&nbsp;C
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-d-topic.html#jam-in-door-d_sk" title="Zaseknut&yacute; papier v&nbsp;dvierkach&nbsp;D">
      Zaseknut&yacute; papier v&nbsp;dvierkach&nbsp;D
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-3000-sheet-tray-topic.html#jam-in-3000-sheet-tray_sk" title="Zaseknutie papiera v 3000-h&aacute;rkovom z&aacute;sobn&iacute;ku">
      Zaseknutie papiera v 3000-h&aacute;rkovom z&aacute;sobn&iacute;ku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-booklet-finisher-topic.html#jam-in-booklet-finisher_sk" title="Zaseknutie papiera v&nbsp;dokončovači brož&uacute;r">
      Zaseknutie papiera v&nbsp;dokončovači brož&uacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-staple-finisher-topic.html#jam-in-staple-finisher_sk" title="Zaseknutie papiera v&nbsp;zo&scaron;&iacute;vačke">
      Zaseknutie papiera v&nbsp;zo&scaron;&iacute;vačke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-in-staple-finisher-topic.html#staple-jam-in-staple-finisher_sk" title="Zaseknutie spinky v&nbsp;zo&scaron;&iacute;vačke">
      Zaseknutie spinky v&nbsp;zo&scaron;&iacute;vačke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-in-staple-hole-punch-finisher-topic.html#staple-jam-in-staple-hole-punch-finisher_sk" title="Zaseknutie spinky v&nbsp;zo&scaron;&iacute;vačke s&nbsp;dierovačom">
      Zaseknutie spinky v&nbsp;zo&scaron;&iacute;vačke s&nbsp;dierovačom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-in-booklet-finisher-topic.html#staple-jam-in-booklet-finisher_sk" title="Zaseknutie spinky v&nbsp;dokončovači brož&uacute;r">
      Zaseknutie spinky v&nbsp;dokončovači brož&uacute;r
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sk" title="Rie&scaron;enie probl&eacute;mov">
     Rie&scaron;enie probl&eacute;mov
    </a>
   </p>
   <div id="divd0e21658">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e21661" title="Probl&eacute;my so sieťov&yacute;m pripojen&iacute;m">
      Probl&eacute;my so sieťov&yacute;m pripojen&iacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e21879" title="Probl&eacute;my s&nbsp;hardv&eacute;rov&yacute;mi voliteľn&yacute;mi prvkami">
      Probl&eacute;my s&nbsp;hardv&eacute;rov&yacute;mi voliteľn&yacute;mi prvkami
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-non-lexmark-supply-see-users-guide-topic.html#d0e22025" title="Probl&eacute;my so&nbsp;spotrebn&yacute;m materi&aacute;lom">
      Probl&eacute;my so&nbsp;spotrebn&yacute;m materi&aacute;lom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_sk" title="Probl&eacute;my s&nbsp;pod&aacute;van&iacute;m papiera">
      Probl&eacute;my s&nbsp;pod&aacute;van&iacute;m papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_sk" title="Probl&eacute;my s&nbsp;tlačou">
      Probl&eacute;my s&nbsp;tlačou
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#d0e24684" title="Probl&eacute;my s&nbsp;kvalitou farieb">
      Probl&eacute;my s&nbsp;kvalitou farieb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-send-receive-fax-topic.html#d0e24935" title="Probl&eacute;my s&nbsp;faxovan&iacute;m">
      Probl&eacute;my s&nbsp;faxovan&iacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-scanner-registration-topic.html#d0e25265" title="Probl&eacute;my so skenovan&iacute;m">
      Probl&eacute;my so skenovan&iacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sk" title="Kontaktovanie podpory pre z&aacute;kazn&iacute;kov">
      Kontaktovanie podpory pre z&aacute;kazn&iacute;kov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_sk" title="Inov&aacute;cia a&nbsp;migr&aacute;cia">
     Inov&aacute;cia a&nbsp;migr&aacute;cia
    </a>
   </p>
   <div id="divd0e25783">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e25786" title="Hardv&eacute;r">
      Hardv&eacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e26366" title="Softv&eacute;r">
      Softv&eacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e26443" title="Firmv&eacute;r">
      Firmv&eacute;r
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sk" title="Upozornenia">
     Upozornenia
    </a>
   </p>
   <div id="divd0e26513">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e26516" title="Inform&aacute;cie o&nbsp;produkte">
      Inform&aacute;cie o&nbsp;produkte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e26533" title="Pozn&aacute;mky k vydaniu">
      Pozn&aacute;mky k vydaniu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sk" title="Ochrann&eacute; zn&aacute;mky">
      Ochrann&eacute; zn&aacute;mky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sk" title="Inform&aacute;cie o&nbsp;licencovan&iacute;">
      Inform&aacute;cie o&nbsp;licencovan&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sk" title="Hladiny emisi&iacute; hluku">
      Hladiny emisi&iacute; hluku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sk" title="Smernica o&nbsp;odpade z&nbsp;elektrick&yacute;ch a&nbsp;elektronick&yacute;ch zariaden&iacute; (WEEE)">
      Smernica o&nbsp;odpade z&nbsp;elektrick&yacute;ch a&nbsp;elektronick&yacute;ch zariaden&iacute; (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e26638" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sk" title="Likvid&aacute;cia produktu">
      Likvid&aacute;cia produktu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e26672" title="Nab&iacute;jateľn&aacute; l&iacute;tium-i&oacute;nov&aacute; bat&eacute;ria">
      Nab&iacute;jateľn&aacute; l&iacute;tium-i&oacute;nov&aacute; bat&eacute;ria
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sk" title="Nariadenie (E&Uacute;) 2023/1542">
      Nariadenie (E&Uacute;) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sk" title="Vr&aacute;tenie kaziet Lexmark na op&auml;tovn&eacute; použitie alebo recykl&aacute;ciu">
      Vr&aacute;tenie kaziet Lexmark na op&auml;tovn&eacute; použitie alebo recykl&aacute;ciu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sk" title="Upozornenie o&nbsp;statickej citlivosti">
      Upozornenie o&nbsp;statickej citlivosti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sk" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sk" title="Inform&aacute;cie o teplot&aacute;ch">
      Inform&aacute;cie o teplot&aacute;ch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sk" title="Vyhl&aacute;senie o&nbsp;laserovom zariaden&iacute;">
      Vyhl&aacute;senie o&nbsp;laserovom zariaden&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e26778" title="&Scaron;t&iacute;tok s odpor&uacute;čaniami v&nbsp;s&uacute;vislosti s použ&iacute;van&iacute;m laserov&eacute;ho zariadenia">
      &Scaron;t&iacute;tok s odpor&uacute;čaniami v&nbsp;s&uacute;vislosti s použ&iacute;van&iacute;m laserov&eacute;ho zariadenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sk" title="Spotreba energie">
      Spotreba energie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_sk" title="Regulačn&eacute; upozornenia t&yacute;kaj&uacute;ce sa koncov&yacute;ch telekomunikačn&yacute;ch zariaden&iacute;">
      Regulačn&eacute; upozornenia t&yacute;kaj&uacute;ce sa koncov&yacute;ch telekomunikačn&yacute;ch zariaden&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_sk" title="Zhoda so smernicami Eur&oacute;pskeho spoločenstva (ES)">
      Zhoda so smernicami Eur&oacute;pskeho spoločenstva (ES)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_sk" title="Upozornenie o&nbsp;r&aacute;diovej interferencii">
      Upozornenie o&nbsp;r&aacute;diovej interferencii
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue